<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'编辑用户':'新增用户'" :visible.sync="dialog" @close="unShowClick()" width="35%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="用户名称" prop="name" :label-width="formLabelWidth" v-if="activeName == 'zh'">
					<el-input style="width: 100%;" v-model="addBody.name" placeholder="请输入用户名称"></el-input>
				</el-form-item>
				<el-form-item label="区号" :label-width="formLabelWidth">
					<el-select style="width: 100%;" v-model="areaCode" placeholder="请选择区号">
						<el-option key="+86" label="+86" value="+86">
						</el-option>
						<el-option key="+886" label="+886" value="+886">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="登陆手机号" :label-width="formLabelWidth" prop="phone">
					<el-input style="width: 100%;" v-model="addBody.phone" placeholder="请输入登陆手机号"></el-input>
				</el-form-item>
				<el-form-item label="关联企业" prop="" :label-width="formLabelWidth">
					<el-select style="width: 100%;" v-model="addBody.business_uuid" placeholder="请选择关联企业">
						<el-option v-for="item in lmList" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="updateUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		addUser,
		updateUser,
		getUserDetail,
		getBusinessList
	} from '@/api/user'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					business_uuid: '',
					name: '',
					phone: "",
					uuid: '',
				},
				areaCode: '+86',
				images: [],
				roleUuid: "",
				rules: {
					business_uuid: [{
						required: true,
						message: '请选择企业',
						trigger: 'blur'
					}, ],
					areaCode: [{
						required: true,
						message: '请选择区号',
						trigger: 'blur'
					}, ],
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}, {
						min: 1,
						max: 20,
						message: '请输入1-20位字母、数字、汉字',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, {
						pattern: /^1[3-9]\d{9}$/,
						message: '手机号格式不正确',
						trigger: 'blur'
					}],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: []
			}
		},
		mounted() {
			this.getBusinessList()
		},
		methods: {
			async getBusinessList() {
				const {
					data
				} = await getBusinessList({})
				this.lmList = data.result.data
			},
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			updateUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().updateUser()
						} else {
							this.network().addUser()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addUser: async () => {
						const {
							status,
							data
						} = await addUser({
							business_uuid: this.addBody.business_uuid,
							name: this.addBody.name,
							phone: this.areaCode + '' + this.addBody.phone,
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					updateUser: async () => {
						const {
							status
						} = await updateUser({
							business_uuid: this.addBody.business_uuid,
							name: this.addBody.name,
							phone: this.areaCode + '' + this.addBody.phone,
							uuid: this.addBody.uuid
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getUserDetail: async (uuid) => {
						const {
							data,
							status
						} = await getUserDetail({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.images = []
				if (val.uuid) {
					this.isEdit = true;
					this.network().getUserDetail(val.uuid)
				} else {
					this.isEdit = false
					this.addBody.name = ''
					this.addBody.phone = ''
					this.addBody.business_uuid = ''
					this.addBody.uuid = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>